module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-24.f10c8d0c.png";